import(/* webpackMode: "eager" */ "/opt/build/repo/app/(auth)/login/page.tsx");
